let ConfirmButton = null;
let clickConfirmType = false;
let clickCancelType = false;
let isDragging = false;
let startX = 0;
let startY = 0;
let currentX = 0;
let currentY = 0;
let ids = [];
let buttonType = "";
import store from "@/store";
import { Message } from "element-ui";
import { name } from "file-loader";
import { MoveEnts, CopyEnts, MirrorEnts } from "./edit";
import { clearEntityArrayHighlight } from "./operateApi";
// 拖动相关函数
const handleDragStart = (e) => {
  isDragging = true;
  if (e.type === "mousedown") {
    startX = e.clientX - ConfirmButton.offsetLeft;
    startY = e.clientY - ConfirmButton.offsetTop;
  } else if (e.type === "touchstart") {
    startX = e.touches[0].clientX - ConfirmButton.offsetLeft;
    startY = e.touches[0].clientY - ConfirmButton.offsetTop;
  }
};

const handleDragMove = (e) => {
  if (!isDragging) return;

  if (e.type === "mousemove") {
    currentX = e.clientX - startX;
    currentY = e.clientY - startY;
  } else if (e.type === "touchmove") {
    currentX = e.touches[0].clientX - startX;
    currentY = e.touches[0].clientY - startY;
  }

  // 限制在视口范围内
  const maxX = window.innerWidth - ConfirmButton.offsetWidth;
  const maxY = window.innerHeight - ConfirmButton.offsetHeight;

  currentX = Math.max(0, Math.min(currentX, maxX));
  currentY = Math.max(0, Math.min(currentY, maxY));

  ConfirmButton.style.left = currentX + "px";
  ConfirmButton.style.top = currentY + "px";
};

const handleDragEnd = () => {
  isDragging = false;
};

//获取按钮
export const getConfirmButton = () => {
  return ConfirmButton;
};

//创建按钮
export const createConfirmButton = (type) => {
  buttonType = type;
  // 检查按钮是否已存在，如果存在则先销毁
  if (ConfirmButton) {
    destroyConfirmButton();
  }
  // 重置点击状态
  clickConfirmType = false;
  clickCancelType = false;
  // 添加合并拆分按钮点击事件监听
  window.addEventListener("confirmButtonClick", handleConfirmButtonClick);
  ConfirmButton = document.createElement("div");
  ConfirmButton.className = "rl-confirm-button";

  // 设置基本样式
  ConfirmButton.style.cssText = `
    position: fixed !important;
    top: 50px !important;
    right: 50px !important;
    z-index: 99999 !important;
    display: inline-flex !important;
    flex-direction: row !important;
    gap: 4px !important;
    background: rgba(255, 255, 255, 0.9) !important;
    padding: 4px !important;
    border-radius: 4px !important;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1) !important;
    backdrop-filter: blur(2px) !important;
    width: fit-content !important;
    user-select: none !important;
    -webkit-user-select: none !important;
    touch-action: none !important;
  `;

  // 创建拖动区域
  const dragHandle = document.createElement("div");
  dragHandle.style.cssText = `
    width: 20px !important;
    height: 24px !important;
    background: rgba(0, 0, 0, 0.1) !important;
    border-radius: 3px !important;
    cursor: move !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    margin-right: 4px !important;
    touch-action: none !important;
  `;

  // 添加拖动图标
  const dragIcon = document.createElement("div");
  dragIcon.style.cssText = `
    width: 12px !important;
    height: 12px !important;
    background: repeating-linear-gradient(
      45deg,
      rgba(0, 0, 0, 0.3) 0px,
      rgba(0, 0, 0, 0.3) 1px,
      transparent 1px,
      transparent 4px
    ) !important;
    border-radius: 2px !important;
  `;
  dragHandle.appendChild(dragIcon);

  // 创建按钮
  const createButton = (text, type, isVisible = true) => {
    const button = document.createElement("button");
    button.innerHTML = text;
    button.style.cssText = `
      width: 60px !important;
      height: 24px !important;
      border: none !important;
      border-radius: 3px !important;
      cursor: pointer !important;
      font-size: 12px !important;
      display: ${isVisible ? "block" : "none"} !important;
      transition: all 0.2s ease !important;
      font-weight: 500 !important;
      letter-spacing: 0.5px !important;
      text-align: center !important;
      line-height: 24px !important;
      padding: 0 !important;
      margin: 0 !important;
      box-shadow: 0 1px 2px rgba(0,0,0,0.1) !important;
      flex-shrink: 0 !important;
      touch-action: none !important;
    `;

    if (type === "primary") {
      button.style.cssText += `
        background: linear-gradient(135deg, #409EFF, #337ecc) !important;
        color: #fff !important;
      `;
    } else {
      button.style.cssText += `
        background: linear-gradient(135deg, #909399, #6b6d71) !important;
        color: #fff !important;
      `;
    }

    // 添加悬停效果
    button.addEventListener("mouseover", () => {
      button.style.transform = "scale(1.05)";
      button.style.boxShadow = "0 2px 4px rgba(0,0,0,0.2)";
    });

    button.addEventListener("mouseout", () => {
      button.style.transform = "scale(1)";
      button.style.boxShadow = "0 1px 2px rgba(0,0,0,0.1)";
    });

    // 添加点击效果
    button.addEventListener("mousedown", () => {
      button.style.transform = "scale(0.95)";
    });

    button.addEventListener("mouseup", () => {
      button.style.transform = "scale(1)";
    });

    return button;
  };

  // 创建三个按钮
  const confirmButton = createButton("确认", "primary");
  const cancelButton = createButton("取消", "info");

  // 添加点击事件
  confirmButton.addEventListener("click", (e) => {
    e.stopPropagation(); // 阻止冒泡
    clickConfirmType = true;
    // 触发自定义事件，通知父组件执行清理
    window.dispatchEvent(
      new CustomEvent("confirmButtonClick", {
        detail: { type: "confirm" },
      })
    );
  });

  cancelButton.addEventListener("click", (e) => {
    e.stopPropagation(); // 阻止冒泡
    clickCancelType = true;
    // 触发自定义事件，通知父组件执行清理
    window.dispatchEvent(
      new CustomEvent("confirmButtonClick", { detail: { type: "cancel" } })
    );
  });
  // 添加拖动事件监听器到拖动区域
  dragHandle.addEventListener("mousedown", handleDragStart);
  dragHandle.addEventListener("touchstart", handleDragStart, {
    passive: false,
  });
  document.addEventListener("mousemove", handleDragMove);
  document.addEventListener("mouseup", handleDragEnd);
  document.addEventListener("touchmove", handleDragMove, { passive: false });
  document.addEventListener("touchend", handleDragEnd);

  // 添加拖动区域和按钮到容器
  ConfirmButton.appendChild(dragHandle);
  ConfirmButton.appendChild(confirmButton);
  ConfirmButton.appendChild(cancelButton);
  // 移除重复的 cancelButton 添加

  // 添加到body
  if (document.body) {
    document.body.appendChild(ConfirmButton);
  }

  return ConfirmButton;
};

//获取点击状态
export const getClickConfirmType = () => {
  return clickConfirmType;
};
export const getClickCancelType = () => {
  return clickCancelType;
};
//设置点击状态
export const setClickConfirmType = (type) => {
  clickConfirmType = type;
};

export const setClickCancelType = (type) => {
  clickCancelType = type;
};

export const handleConfirmButtonClick = async (e) => {
  const { type } = e.detail;
  if (type === "confirm") {
    if (ids.length == 0) {
      rlAppObj._rlMx.MxFun.stopRunCommand();
    } else {
      console.log("确认");
      if (buttonType === "move") {
        MoveEnts(ids);
      } else if (buttonType === "copy") {
        CopyEnts(ids);
      } else if (buttonType === "mirror") {
        MirrorEnts(ids);
      } else if (buttonType === "AseismaticEntiretyJoin") {
        rlAppObj._rlMx.MxFun.stopRunCommand();
      }
    }
  } else if (type === "cancel") {
    console.log("取消");
    clearEntityArrayHighlight();
    rlAppObj._rlMx.MxFun.stopRunCommand();
  }
  setTimeout(() => {
    destroyConfirmButton();
  }, 50);
};

//销毁按钮
export const destroyConfirmButton = () => {
  if (ConfirmButton) {
    // 移除事件监听器
    document.removeEventListener("mousemove", handleDragMove);
    document.removeEventListener("mouseup", handleDragEnd);
    document.removeEventListener("touchmove", handleDragMove);
    document.removeEventListener("touchend", handleDragEnd);

    ConfirmButton.remove();
    ConfirmButton = null;
  }
  clickConfirmType = false;
  clickCancelType = false;
  ids = [];
  window.removeEventListener("confirmButtonClick", handleConfirmButtonClick);
  store.commit("inspectionStore/setIsInCommand", false);
};

//修改按钮位置
export const setConfirmButtonPosition = (x, y) => {
  if (!ConfirmButton) {
    return;
  }
  // 坐标转换
  const selectObjPoint = rlAppObj._rlMx.MxFun.cadCoord2Doc(x, y);
  // 将文档坐标转换为屏幕坐标
  const pxPoint = rlAppObj._rlMx.MxFun.docCoord2Screen(
    selectObjPoint.x,
    selectObjPoint.y
  );
  ConfirmButton.style.left = pxPoint.x + "px";
  ConfirmButton.style.top = pxPoint.y + "px";
};

export const setIds = (data) => {
  for (let i = 0; i < data.length; i++) {
    if (!ids.includes(data[i])) {
      ids.push(data[i]);
    }
  }
};

export const getIds = () => {
  return ids;
};
